import { call, put } from 'redux-saga/effects';
import { waitingEntryNotificationUpdateRequested } from 'features/notifications/actions';
import { signalingWaitingUserLeft, signalingWaitingUserLeftBatch } from 'features/users/actions';
import { sendWaitingUsersLeftSaga } from 'features/users/sagas/sendWaitingUsersLeftSaga';

export function* onWaitingUserLeftSaga(
  action: ReturnType<typeof signalingWaitingUserLeft | typeof signalingWaitingUserLeftBatch>
) {
  const userIds =
    'users' in action.payload ? action.payload.users.map((user) => user.id) : [action.payload.id];

  yield call(sendWaitingUsersLeftSaga, userIds);

  yield put(waitingEntryNotificationUpdateRequested());
}
